/* cryogear-extras.js — Cryogear homepage tweaks (v10: clean simple white slide + bounded img) */
(function () {
  "use strict";

  function convertHousesToMarquee() {
    var section = document.querySelector('[id*="houses_grid"]');
    if (!section) return;
    var slidesEl = section.querySelector('slideshow-slides');
    if (!slidesEl) return;

    if (!document.getElementById('cryogear-marquee-styles')) {
      var style = document.createElement('style');
      style.id = 'cryogear-marquee-styles';
      style.textContent = `
        slideshow-slides[data-cryogear-marquee] {
          overflow: hidden !important;
          scroll-snap-type: none !important;
          scroll-behavior: auto !important;
          display: flex !important;
          flex-wrap: nowrap !important;
          width: 100% !important;
          --marquee-duration: 50s;
          --marquee-slide-width: 242px;
          --marquee-slide-height: 150px;
          --marquee-gap: 0px;
          --logo-max-width: 228px;
          --logo-max-height: 148px;
        }
        slideshow-slides[data-cryogear-marquee] .marquee-track {
          display: flex !important;
          flex-wrap: nowrap !important;
          gap: var(--marquee-gap) !important;
          padding-right: var(--marquee-gap) !important;
          animation: cryogear-marquee var(--marquee-duration) linear infinite;
          will-change: transform;
          flex-shrink: 0;
        }
        slideshow-slides[data-cryogear-marquee]:hover .marquee-track { animation-play-state: paused; }
        /* The SLIDE is the white tile, edge to edge */
        slideshow-slides[data-cryogear-marquee] slideshow-slide,
        slideshow-slides[data-cryogear-marquee] .resource-list__slide {
          flex: 0 0 var(--marquee-slide-width) !important;
          width: var(--marquee-slide-width) !important;
          height: var(--marquee-slide-height) !important;
          scroll-snap-align: none !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 0 !important;
          box-sizing: border-box !important;
          overflow: hidden !important;
          background: #FFFFFF !important;
          border-radius: 2px !important;
          margin: 0 !important;
        }
        /* All inner wrappers — transparent, no padding/margin, no aspect-ratio constraint */
        slideshow-slides[data-cryogear-marquee] .resource-list__item,
        slideshow-slides[data-cryogear-marquee] .collection-card,
        slideshow-slides[data-cryogear-marquee] .collection-card__link,
        slideshow-slides[data-cryogear-marquee] .collection-card__inner,
        slideshow-slides[data-cryogear-marquee] .resource-image,
        slideshow-slides[data-cryogear-marquee] .collection-card__image {
          width: 100% !important;
          height: 100% !important;
          aspect-ratio: auto !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 0 !important;
          margin: 0 !important;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }
        slideshow-slides[data-cryogear-marquee] .collection-card__content { display: none !important; }
        /* IMG: bounded by explicit pixel max sizes (NOT 100%), centered */
        slideshow-slides[data-cryogear-marquee] img {
          width: auto !important;
          height: auto !important;
          max-width: var(--logo-max-width) !important;
          max-height: var(--logo-max-height) !important;
          object-fit: contain !important;
          object-position: center center !important;
          display: block !important;
          margin: auto !important;
        }
        @keyframes cryogear-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(calc(-50% - (var(--marquee-gap) / 2))); }
        }
        [id*="houses_grid"] .slideshow-control { display: none !important; }
        /* Hide section heading "The Houses" */
        [id*="houses_grid"] .section__heading,
        [id*="houses_grid"] h1, [id*="houses_grid"] h2, [id*="houses_grid"] h3,
        [id*="houses_grid"] [class*="heading"],
        [id*="houses_grid"] [class*="title"] { display: none !important; }
        /* Remove the section background tint */
        [id*="houses_grid"] .section,
        [id*="houses_grid"] .section-wrapper,
        [id*="houses_grid"][class*="color-scheme"] { background: #EEF1F4 !important; }
        /* Force zero margin + padding on the houses section so it butts the marquee_tagline */
        [id*="houses_grid"] { margin: 0 !important; padding: 0 !important; }
        [id*="houses_grid"] > .section { padding-block: 0 !important; margin-block: 0 !important; }
        /* Zero ALL top padding/margin on every ancestor that could push the marquee row down */
        [id*="houses_grid"] *,
        [id*="houses_grid"] > div,
        [id*="houses_grid"] .resource-list,
        [id*="houses_grid"] slideshow-component,
        [id*="houses_grid"] slideshow-slides {
          padding-top: 0 !important;
          margin-top: 0 !important;
        }
        /* Kill flex gap + collapse hidden heading_group's layout reserve */
        [id*="houses_grid"],
        [id*="houses_grid"] > .section,
        [id*="houses_grid"] > div,
        [id*="houses_grid"] [class*="layout"] {
          gap: 0 !important;
          row-gap: 0 !important;
        }
        [id*="houses_grid"] .section__heading,
        [id*="houses_grid"] [class*="heading_group"],
        [id*="houses_grid"] [data-block-type="heading"],
        [id*="houses_grid"] header {
          display: none !important;
          height: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        [id*="marquee_tagline"] { margin-bottom: 0 !important; }
        [id*="marquee_tagline"] > .section { padding-block-end: 16px !important; margin-block-end: 0 !important; --marquee-direction: reverse !important; }
        /* Blue-grey hairline borders top + bottom of the houses_grid marquee — matches Cryogear palette */
        [id*="houses_grid"] {
          border-top: 1px solid #8A9DAE !important;
          border-bottom: 1px solid #8A9DAE !important;
        }
        @media (prefers-reduced-motion: reduce) {
          slideshow-slides[data-cryogear-marquee] .marquee-track { animation: none; }
        }
        @media (max-width: 749px) {
          slideshow-slides[data-cryogear-marquee] {
            --marquee-slide-width: 176px;
            --marquee-slide-height: 116px;
            --marquee-duration: 40s;
            --logo-max-width: 168px;
            --logo-max-height: 108px;
          }
        }
      `;
      document.head.appendChild(style);
    }

    if (slidesEl.hasAttribute('data-cryogear-marquee')) return;

    var slides = Array.from(slidesEl.children).filter(function (n) {
      return n.tagName && /slideshow-slide|resource-list__slide/i.test(n.tagName + ' ' + (n.className || ''));
    });
    if (slides.length < 2) return;

    var trackA = document.createElement('div');
    trackA.className = 'marquee-track';
    slides.forEach(function (s) { trackA.appendChild(s); });

    var trackB = document.createElement('div');
    trackB.className = 'marquee-track';
    trackB.setAttribute('aria-hidden', 'true');
    slides.forEach(function (s) {
      var clone = s.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      trackB.appendChild(clone);
    });

    slidesEl.innerHTML = '';
    slidesEl.appendChild(trackA);
    slidesEl.appendChild(trackB);
    slidesEl.setAttribute('data-cryogear-marquee', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertHousesToMarquee);
  } else {
    convertHousesToMarquee();
  }
})();

/* Tagline padding + heading_group hide — injected as <style> to avoid CSS-in-JS parse errors */
(function () {
  "use strict";
  function injectTaglineCss() {
    if (document.getElementById('cryogear-tagline-extras')) return;
    var style = document.createElement('style');
    style.id = 'cryogear-tagline-extras';
    style.textContent = [
      '[id*="marquee_tagline"] marquee-component {',
      '  padding-bottom: 16px !important;',
      '}',
      /* Re-hide the houses_grid heading if it somehow re-appeared */
      '[id*="houses_grid"] .heading_group,',
      '[id*="houses_grid"] .section-resource-list__heading,',
      '[id*="houses_grid"] .section-resource-list__content > .heading_group {',
      '  display: none !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTaglineCss);
  } else {
    injectTaglineCss();
  }
})();

/* Tagline padding + heading_group hide */
(function () {
  "use strict";
  function injectTaglineCss() {
    if (document.getElementById('cryogear-tagline-extras')) return;
    var style = document.createElement('style');
    style.id = 'cryogear-tagline-extras';
    style.textContent = [
      '[id*="marquee_tagline"] marquee-component { --padding-block-end: 16px !important; padding-bottom: 16px !important; }',
      '[id*="houses_grid"] .heading_group,',
      '[id*="houses_grid"] .section-resource-list__heading,',
      '[id*="houses_grid"] .section-resource-list__content > .heading_group { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTaglineCss);
  } else {
    injectTaglineCss();
  }
})();
